<template>
  <div class="container">
    <van-cell-group>
      <AirlineSelector @selected="onAirlineSelected" :placeholder="this.$t('Airline')"></AirlineSelector>
    </van-cell-group>
    <van-cell-group>
      <van-field v-model="flightNumber" :placeholder="$t('Flight No.')"/>
    </van-cell-group>
    <van-cell-group>
      <van-cell @click="showDatePickup = true">
        <slot name="title">
          <span>{{ $t('Departing Date') }}</span>
          <span class="departingDate-name">{{ departingDate.name }}</span>
          <van-icon name="arrow-down" slot="right-icon"/>
        </slot>
      </van-cell>
    </van-cell-group>
    <div class="no-result" v-if="noResult">{{ $t('No results to display') }}</div>
    <van-button size="large" type="info" class="button-find-flight" @click="getFlights">{{ $t('Find flights') }}
    </van-button>

    <van-actionsheet
      v-model="showDatePickup"
      :actions="dateList"
      @select="onDateSelected"
    />
  </div>
</template>

<script>
import AirlineSelector from '../components/AirlineSelector'

const langs = ['ru', 'de'] // DD/MM/YY 日期格式的语种
export default {
  name: 'FlightNumber',
  components: {
    AirlineSelector
  },
  data () {
    return {
      airline: '',
      flightNumber: '',
      departingDate: null,
      showDatePickup: false,
      dateList: [],
      noResult: false,
    }
  },
  watch: {
    departingDate (val) {
      for (let key in this.dateList) {
        if (val.name === this.dateList[key].name) {
          for (let i in this.dateList) {
            this.dateList[i].className = ''
          }
          this.dateList[key].className = 'selectedDate'
        }
      }
    }
  },
  created () {
    this.formatDate()
  },
  methods: {
    formatDate () {
      let formatRule = 'DD-MM-YYYY'
      if (langs.indexOf(localStorage.getItem('lang')) !== -1) {
        formatRule = 'DD/MM/YYYY'
      }
      this.departingDate = {
        name: this.$t('Today'),
        subname: this.$moment().format(formatRule)
      }
      this.dateList = [
        {
          name: this.$t('Yesterday'),
          subname: this.$moment().add(-1, 'day').format(formatRule)
        },
        {
          name: this.$t('Today'),
          subname: this.$moment().format(formatRule),
          className: 'selectedDate'
        },
        {
          name: this.$t('Tomorrow'),
          subname: this.$moment().add(1, 'days').format(formatRule)
        },
        {
          name: this.$t('Day after tomorrow'),
          subname: this.$moment().add(2, 'days').format(formatRule)
        }
      ]
    },
    onAirlineSelected (airline) {
      this.flightNumber = ''
      this.airline = airline.code
      this.flightNumber = this.airline + this.flightNumber
    },
    onDateSelected (date) {
      this.showDatePickup = false
      this.departingDate = date
    },
    getFlights () {
      let fnum = this.flightNumber
      let datastr = this.departingDate.subname
      if (langs.indexOf(localStorage.getItem('lang')) !== -1) {
        datastr = datastr.split('/')
      } else {
        datastr = datastr.split('-')
      }
      let date = `${datastr[2]}-${datastr[1]}-${datastr[0]}`
      let url = this.$urlHelper.byFlightNumber(fnum, date)
      this.$http.get(url).then(response => {
        this.noResult = false
        if (response.status === 200 && !response.data.error) {
          this.$gtm.push({
            'event': 'screenview',
            'site_type': sessionStorage.getItem('site_type'),
            'brand': 'edreams',
            'screenName': '/flights-tracker/numbers/results/',
            'lang': localStorage.getItem('cod_lang') || localStorage.getItem('lang'),
            'cid': localStorage.getItem('cid')
          })
          if (response.data.length === 1) {
            let fnum = response.data[0].FlightNo
            let date = this.$moment(response.data[0].FlightDeptimePlanDate).format('YYYY-MM-DD')
            let dep = response.data[0].FlightDepcode
            let arr = response.data[0].FlightArrcode
            this.$store.state.flight = response.data[0]
            this.$store.commit('setFlight', response.data[0])
            this.$router.push(`/flight?fnum=${fnum}&dep=${dep}&arr=${arr}&date=${date}&cid=${localStorage.getItem('cid')}`)
            return
          }
          let searchProps = {
            fnum,
            date: this.departingDate.subname
          }
          sessionStorage.setItem('searchProps', JSON.stringify(searchProps))
          sessionStorage.setItem('flightList', JSON.stringify(response.data))
          sessionStorage.setItem('searchType', 'flightNumber')
          this.$router.push('/SearchList')
        } else {
          this.noResult = true
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  computed: {
    queryString () {
      return `fnum=${this.airline}${this.flightNumber}&date=${this.departingDate.subname}`
    }
  }
}
</script>

<style scoped>

  .van-field ::placeholder {
    color: #999;
  }

  .van-actionsheet__item {
    text-align: left;
    margin: 0 10px;
    border-bottom: 1px solid #DEE4E9;
  }

  .van-actionsheet__item:last-child {
    border-bottom: 0;
  }

  .selectedDate {
    color: #90A9B9;
  }

  .selectedDate .van-actionsheet__subname {
    color: #90A9B9;
  }

  .van-hairline--top-bottom::after {
    border-width: 0;
  }

  .actionsheet {
    text-align: left;
  }

  .van-cell {
    padding: 0px 15px 0px 8px;
    font-size: 16px;
  }

  .departingDate-name {
    color: #7d7e80;
    font-size: 12px;
    margin-left: 5px;
  }

  .van-icon-arrow-down {
    line-height: 25px;
    color: #999;
  }

  .no-result {
    line-height: 50px;
    text-align: center;
    font-size: 13px;
    color: #969799;
  }
</style>
